/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

/**
 * Interface for multi items added to cart resource.
 */
export interface IItemsAddedToCartResources {
    viewCartButtonText: string;
    closeButtonLabel: string;
    itemsAddedToCartHeaderText: string;
    itemsAddedToCartFormatText: string;
    linesAddedToCartFormatText: string;
    itemsAddedValidationErrorMessage?: string;
}

/**
 * Interface for add to cart input.
 */
export interface IAddToCartInput {
    product: SimpleProduct;
    count?: number;
}

/**
 * The total number of items.
 * @param addedInput -- The added to cart input.
 * @returns The total number of items.
 */
export const getTotalItems = (addedInput: IAddToCartInput[]): number => {
    const defaultQuantity: number = 1;
    let totalCount: number = 0;

    for (const item of addedInput) {
        totalCount += item.count ?? defaultQuantity;
    }

    return totalCount;
};
